<template>
  <div class="row">
    <div class="col-md-3">
      <div class="row">
        <div class="col-md-12 margin-bottom">
          <img
            :src="borrower_photo"
            @error="(e) => {e.target.src='/img/take_photo_with_id.jpg'}"
            class="img-thumbnail img-responsive"
            alt="Selfie Photo"
          >
        </div>
        <div class="col-md-12 margin-bottom">
          <img
            :src="borrower_national_id_photo"
            @error="(e) => {e.target.src='/img/national_id_card.jpg'}"
            class="img-thumbnail img-responsive"
            alt="National ID Card"
          >
        </div>
        <template v-if="client.type === 'Pawn' || client.type === 'Purchasing'">
          <div class="col-md-12">
            <img
              :src="borrower_employment_card_photo"
              @error="(e) => {e.target.src='/img/employee_card.png'}"
              class="img-thumbnail img-responsive"
              alt="Employee Card"
            >
          </div>
        </template>
      </div>
    </div>
    <div class="col-md-9">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                {{ $t('label.information') }}
              </h3>
              <div class="box-tools">
                <button
                  @click="$router.push(routeBackToList)"
                  class="btn btn-default btn-sm btn-back"
                >
                  {{ $t('button.back') }}
                </button>
              </div>
            </div>
            <div class="box-body">
              <table
                class="table table-bordered table-striped"
                v-if="client"
              >
                <tbody>
                  <tr>
                    <th>{{ $t('label.name') }}</th>
                    <td class="text-muted">
                      : {{ client.name }} {{ client.last_name }}
                    </td>
                    <th>{{ $t('label.nationalIdNumber') }}</th>
                    <td class="text-muted">
                      : {{ client.national_id_number }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.phone') }}</th>
                    <td class="text-muted">
                      : {{ client.phone }}
                    </td>
                    <th>{{ $t('label.email') }}</th>
                    <td class="text-muted">
                      : {{ client.email }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.dateOfBirth') }}</th>
                    <td class="text-muted">
                      : {{ client.date_of_birth }}
                    </td>
                    <th>{{ $t('label.gender') }}</th>
                    <td class="text-muted">
                      : {{ client.gender }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.streetNumber') }}</th>
                    <td class="text-muted">
                      : {{ client.street_number || 'N/A' }}
                    </td>
                    <th>{{ $t('label.homeNumber') }}</th>
                    <td class="text-muted">
                      : {{ client.home_number || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.village') }}</th>
                    <td class="text-muted">
                      : {{ client.village || 'N/A' }}
                    </td>
                    <th>{{ $t('label.commune') }}</th>
                    <td class="text-muted">
                      : {{ client.commune || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.district') }}</th>
                    <td class="text-muted">
                      : {{ client.district || 'N/A' }}
                    </td>
                    <th>{{ $t('label.province') }}</th>
                    <td class="text-muted">
                      : {{ client.province || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.bankName') }}</th>
                    <td class="text-muted">
                      : {{ client.bank_name || 'N/A' }}
                    </td>
                    <th>{{ $t('label.bankAccountNumber') }}</th>
                    <td class="text-muted">
                      : {{ client.bank_account_number || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.relativeName') }}</th>
                    <td class="text-muted">
                      : {{ client.relative_name || 'N/A' }}
                    </td>
                    <th>{{ $t('label.relativeContactPhone') }}</th>
                    <td class="text-muted">
                      : {{ client.relative_contact_phone || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.relativeType') }}</th>
                    <td class="text-muted">
                      : {{ client.relative_type || 'N/A' }}
                    </td>
                    <th>{{ $t('label.sourceOfInformation') }}</th>
                    <td class="text-muted">
                      : {{ client.source_of_information || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.companyName') }}</th>
                    <td class="text-muted">
                      : {{ client.company_name || 'N/A' }}
                    </td>
                    <th>{{ $t('label.companyType') }}</th>
                    <td class="text-muted">
                      : {{ client.company_type || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.companyContactName') }}</th>
                    <td class="text-muted">
                      : {{ client.company_contact_name || 'N/A' }}
                    </td>
                    <th>{{ $t('label.companyContactPhone') }}</th>
                    <td class="text-muted">
                      : {{ client.company_contact_phone || 'N/A' }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('label.grossMonthlyIncome') }}</th>
                    <td class="text-muted">
                      : {{ client.gross_monthly_income || 'N/A' }}
                    </td>
                    <th>{{ $t('label.studyMajor') }}</th>
                    <td class="text-muted">
                      : {{ client.study_major || 'N/A' }}
                    </td>
                  </tr>
                  <template v-if="client.type === 'Pawn'">
                    <tr>
                      <th>{{ $t('string.typeOfCollateral') }}</th>
                      <td class="text-muted">
                        : {{ client.type_of_collateral || 'N/A' }}
                      </td>
                      <th />
                      <td class="text-muted" />
                    </tr>
                  </template>
                  <template v-else-if="client.type === 'Purchasing'">
                    <tr>
                      <th>{{ $t('fields.purchaseItem') }}</th>
                      <td class="text-muted">
                        : {{ client.purchase_item || 'N/A' }}
                      </td>
                      <th>{{ $t('fields.purchasePrice') }}</th>
                      <td class="text-muted">
                        : {{ client.purchase_total_price || 'N/A' }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicantInformation',
  props: {
    client: {
      type: Object,
      required: true
    },
    routeBackToList: {
      type: Object,
      required: true
    }
  },
  computed: {
    borrower_photo () {
      if (this.client && this.client.borrower_photo) {
        return `${this.baseUrl}/${this.client.borrower_photo}`
      }
      return '/img/tmp_avatar.jpg'
    },
    borrower_national_id_photo () {
      if (this.client && this.client.borrower_national_id_photo) {
        return `${this.baseUrl}/${this.client.borrower_national_id_photo}`
      }
      return '/img/tmp_avatar.jpg'
    },
    borrower_employment_card_photo () {
      if (this.client && this.client.borrower_employment_card_photo) {
        return `${this.baseUrl}/${this.client.borrower_employment_card_photo}`
      }
      return '/img/tmp_avatar.jpg'
    }
  }
}
</script>

<style scoped>

</style>
